// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Main Page Layout === */

.fx-page {
  animation: fadeIn 0.5s ease-in-out;
}
.fx-content-wrapper {
  background-color: #ffffff;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  padding: 24px;
}

.transaction-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 24px;
}

.date-filters,
.right-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.date-filters input[type="date"] {
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  color: #6b7280;
}

.export-buttons {
  display: flex;
  gap: 0.75rem;
}
.export-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}
.export-btn.pdf {
  background-color: #fff4ec;
  color: #ff8a00;
  border-radius: 34%;
}
.export-btn.csv {
  background-color: #f0f6ff;
  color: #1e3a8a;
  border-radius: 34%;
}

.transaction-search-bar {
  display: flex;
  align-items: center;
  background-color: #f9fafb;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 0 12px;
  width: 280px;
}
.transaction-search-bar svg {
  font-size: 18px;
  color: #9ca3af;
}
.transaction-search-bar input {
  border: none;
  outline: none;
  padding: 10px 8px;
  font-size: 14px;
  flex-grow: 1;
  background: transparent;
}

.fx-tabs {
  display: flex;
  gap: 2rem;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 24px;
}
.fx-tabs button {
  background: none;
  border: none;
  padding: 12px 4px;
  font-size: 16px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  position: relative;
  border-bottom: 3px solid transparent;
}
.fx-tabs button.active {
  color: #f97316;
  border-bottom-color: #f97316;
}

/* Reusing your table styles */
.table-container {
  overflow-x: auto;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
}
.data-table th,
.data-table td {
  padding: 16px 24px;
  text-align: left;
  border-bottom: 1px solid #f0f1f3;
  font-size: 14px;
}
.data-table th {
  background-color: #f8fafc;
  color: #475569;
  font-weight: 600;
  text-transform: none;
}
.data-table td {
  color: #374151;
}
.data-table tbody tr:last-child td {
  border-bottom: none;
}

.action-icon {
  font-size: 20px;
  color: #9ca3af;
  cursor: pointer;
}
.status-badge {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}
.status-successful {
  background-color: #dcfce7;
  color: #166534;
}
.status-pending {
  background-color: #fef9c3;
  color: #854d0e;
}
.status-failed {
  background-color: #fee2e2;
  color: #991b1b;
}

.fx-page .page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.fx-page .page-header h3 {
  font-size: 28px;
  font-weight: 600;
  color: #111827;
}

.page-content-wrapper {
  background: #ffffff;
  border: 1px solid #f2f7ff;
  border-radius: 12px;
  padding: 24px;
}

/* === Top Controls Header (Inside the white card) === */
.page-controls-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.date-filters {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.input-with-icon {
  position: relative;
  width: auto;
}
.input-with-icon input {
  background-color: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 6px;
  padding: 10px 12px 10px 40px; /* Default padding for left icon */
  font-size: 14px;
  box-sizing: border-box;
}
.input-with-icon svg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 18px;
  pointer-events: none;
}
.input-with-icon .input-icon-left {
  left: 14px;
}
.input-with-icon .input-icon-right {
  right: 14px;
}
.date-filters .input-with-icon input {
  padding-left: 12px;
  padding-right: 40px; /* Space for right icon */
}

/* === Tabs and Main Content === */
.fx-tabs {
  border-bottom: 2px solid #f3f4f6;
}
.fx-tabs button {
  background: none;
  border: none;
  padding: 0 5px 15px 5px;
  margin-right: 30px;
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
  position: relative;
  font-weight: 500;
}
.fx-tabs button.active {
  color: #f97316;
  font-weight: 600;
}
.fx-tabs button.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #f97316;
}
.fx-content {
  padding-top: 24px;
}

/* === FX Pricing Tab Specifics === */
.fx-pricing-list .list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.fx-pricing-list .list-header h3 {
  font-size: 18px;
  color: #111827;
  margin: 0;
}
.fx-filters {
  display: flex;
  align-items: center;
  gap: 16px;
}
.fx-filters .form-group {
  display: flex;
  align-items: center;
  gap: 8px;
}
.fx-filters .form-group label {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}
.fx-filters .form-group select {
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background-color: #fff;
  font-size: 14px;
}
.action-button.primary {
  background-color: #f97316;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

/* === FX Transaction Tab Specifics === */
/* The transaction tab doesn't have a header above the table, so no specific styles needed */

/* === Shared Table Styles === */
.table-container {
  overflow-x: auto;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
}
.data-table th,
.data-table td {
  padding: 16px 24px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
  font-size: 14px;
  white-space: nowrap;
  vertical-align: middle;
}
.data-table th {
  background-color: #f2f7ff;
  color: #174078;
  font-weight: 600;
}
.data-table td {
  color: #475569;
}
.data-table tbody tr:last-child td {
  border-bottom: none;
}
.action-cell {
  text-align: right !important;
}
.action-icon {
  cursor: pointer;
  color: #6b7280;
  font-size: 20px;
}
.status-badge {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}
.status-successful {
  background-color: #dcfce7;
  color: #166534;
}
.status-pending {
  background-color: #fef9c3;
  color: #854d0e;
}
.status-failed {
  background-color: #fee2e2;
  color: #991b1b;
}

/* === Shared Empty State, Loading, and Error Styles === */
.page-loading,
.page-error,
.no-data-message,
.fx-empty-state {
  text-align: center;
  padding: 60px 20px;
  font-size: 16px;
  color: #6b7280;
  background-color: #f9fafb;
  border-radius: 8px;
}
.page-error {
  color: #ef4444;
}
.fx-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fx-empty-state .icon-wrapper {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: #fff7ed;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  font-size: 70px;
  color: #f97316;
}
.fx-empty-state h3 {
  font-size: 20px;
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 32px;
}

/* --- RESPONSIVE STYLES --- */
@media (max-width: 1200px) {
  .fx-content-wrapper,
  .page-content-wrapper {
    padding: 16px;
  }
}

@media (max-width: 992px) {
  .fx-tabs {
    gap: 1rem;
  }
  .fx-content-wrapper,
  .page-content-wrapper {
    padding: 12px;
  }
  .fx-page .page-header h3 {
    font-size: 22px;
  }
}

@media (max-width: 768px) {
  .fx-content-wrapper,
  .page-content-wrapper {
    padding: 8px;
  }
  .fx-tabs {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .fx-content {
    padding-top: 12px;
  }
  .table-container {
    overflow-x: auto;
  }
  .data-table thead {
    display: none;
  }
  .data-table tr {
    display: block;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    margin-bottom: 1rem;
    padding: 1rem;
  }
  .data-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f3f4f6;
    white-space: normal;
  }
  .data-table td:last-child {
    border-bottom: none;
  }
  .data-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #4b5563;
    text-align: left;
  }
}

.pair-selector-section {
  margin-bottom: 30px;
}
.selector-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.pair-selector {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

/* ── Currency pair cards ── */
.pair-btn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 16px 18px;
  background: #fff;
  border: 1.5px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition:
    border-color 0.2s,
    box-shadow 0.2s,
    background 0.2s;
  text-align: left;
}
.pair-btn:hover:not(:disabled) {
  border-color: #fdba74;
  box-shadow: 0 4px 16px rgba(249, 115, 22, 0.1);
}
.pair-btn.active {
  border-color: #f97316;
  background: #fff7ed;
  box-shadow: 0 4px 20px rgba(249, 115, 22, 0.14);
}
.pair-btn.inactive {
  opacity: 0.55;
  cursor: not-allowed;
  background: #f9fafb;
}
.pair-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
}
.pair-rate {
  font-size: 20px;
  font-weight: 800;
  color: #174078;
  letter-spacing: -0.02em;
}
.pair-btn.active .pair-rate {
  color: #f97316;
}
.coming-soon {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #9ca3af;
  background: #f3f4f6;
  padding: 2px 7px;
  border-radius: 99px;
}

/* ── Stats row ── */
.fx-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 28px;
}
@media (max-width: 900px) {
  .fx-stats-grid {
    grid-template-columns: 1fr;
  }
}
.fx-stat-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.fx-stat-card__icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}
.fx-stat-card__icon--orange {
  background: #fff7ed;
}
.fx-stat-card__icon--blue {
  background: #eff6ff;
}
.fx-stat-card__icon--teal {
  background: #f0fdf4;
  gap: 3px;
  font-size: 11px;
  font-weight: 700;
  flex-direction: row;
}
.fx-stat-card__pair-badge {
  background: #fff;
  border: 1px solid #d1fae5;
  border-radius: 6px;
  padding: 2px 6px;
  color: #065f46;
}
.fx-stat-card__pair-arrow {
  color: #9ca3af;
  font-size: 10px;
}
.fx-stat-card__body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}
.fx-stat-card__label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.fx-stat-card__value {
  font-size: 22px;
  font-weight: 800;
  color: #111827;
  letter-spacing: -0.02em;
  line-height: 1.2;
}
.fx-stat-card__change {
  font-size: 12px;
  font-weight: 600;
  margin-top: 2px;
}
.fx-stat-card__change--up {
  color: #16a34a;
}
.fx-stat-card__change--down {
  color: #dc2626;
}
.fx-stat-card__meta {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 2px;
}

/* ── Inline messages ── */
.message {
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
}
.message-info {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
}
.message-success {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}
.message-error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.fx-inline-error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  margin-bottom: 16px;
}
.fx-table-empty {
  text-align: center;
  padding: 40px 24px !important;
  color: #6b7280;
  font-size: 14px;
}
.fx-pair-chip {
  display: inline-block;
  background: #fff7ed;
  color: #c2410c;
  font-weight: 600;
  font-size: 13px;
  padding: 3px 10px;
  border-radius: 99px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/FXPage/FXPage.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B,EAAE,kCAAkC;EAChE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,yBAAyB;AAChD;;AAEA,kCAAkC;AAClC;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yCAAyC;AACzC,4FAA4F;;AAE5F,gCAAgC;AAChC;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;;IAEE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf;;;mBAGiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["/* === Main Page Layout === */\n\n.fx-page {\n  animation: fadeIn 0.5s ease-in-out;\n}\n.fx-content-wrapper {\n  background-color: #ffffff;\n  border: 1px solid #f3f4f6;\n  border-radius: 12px;\n  padding: 24px;\n}\n\n.transaction-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 24px;\n}\n\n.date-filters,\n.right-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.date-filters input[type=\"date\"] {\n  padding: 8px 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.export-buttons {\n  display: flex;\n  gap: 0.75rem;\n}\n.export-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: none;\n  font-weight: 600;\n  cursor: pointer;\n}\n.export-btn.pdf {\n  background-color: #fff4ec;\n  color: #ff8a00;\n  border-radius: 34%;\n}\n.export-btn.csv {\n  background-color: #f0f6ff;\n  color: #1e3a8a;\n  border-radius: 34%;\n}\n\n.transaction-search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #f9fafb;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 0 12px;\n  width: 280px;\n}\n.transaction-search-bar svg {\n  font-size: 18px;\n  color: #9ca3af;\n}\n.transaction-search-bar input {\n  border: none;\n  outline: none;\n  padding: 10px 8px;\n  font-size: 14px;\n  flex-grow: 1;\n  background: transparent;\n}\n\n.fx-tabs {\n  display: flex;\n  gap: 2rem;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 24px;\n}\n.fx-tabs button {\n  background: none;\n  border: none;\n  padding: 12px 4px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  position: relative;\n  border-bottom: 3px solid transparent;\n}\n.fx-tabs button.active {\n  color: #f97316;\n  border-bottom-color: #f97316;\n}\n\n/* Reusing your table styles */\n.table-container {\n  overflow-x: auto;\n}\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.data-table th,\n.data-table td {\n  padding: 16px 24px;\n  text-align: left;\n  border-bottom: 1px solid #f0f1f3;\n  font-size: 14px;\n}\n.data-table th {\n  background-color: #f8fafc;\n  color: #475569;\n  font-weight: 600;\n  text-transform: none;\n}\n.data-table td {\n  color: #374151;\n}\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.action-icon {\n  font-size: 20px;\n  color: #9ca3af;\n  cursor: pointer;\n}\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n.status-successful {\n  background-color: #dcfce7;\n  color: #166534;\n}\n.status-pending {\n  background-color: #fef9c3;\n  color: #854d0e;\n}\n.status-failed {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.fx-page .page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.fx-page .page-header h3 {\n  font-size: 28px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.page-content-wrapper {\n  background: #ffffff;\n  border: 1px solid #f2f7ff;\n  border-radius: 12px;\n  padding: 24px;\n}\n\n/* === Top Controls Header (Inside the white card) === */\n.page-controls-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.date-filters {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.input-with-icon {\n  position: relative;\n  width: auto;\n}\n.input-with-icon input {\n  background-color: #f8fafc;\n  border: 1px solid #f1f5f9;\n  border-radius: 6px;\n  padding: 10px 12px 10px 40px; /* Default padding for left icon */\n  font-size: 14px;\n  box-sizing: border-box;\n}\n.input-with-icon svg {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  font-size: 18px;\n  pointer-events: none;\n}\n.input-with-icon .input-icon-left {\n  left: 14px;\n}\n.input-with-icon .input-icon-right {\n  right: 14px;\n}\n.date-filters .input-with-icon input {\n  padding-left: 12px;\n  padding-right: 40px; /* Space for right icon */\n}\n\n/* === Tabs and Main Content === */\n.fx-tabs {\n  border-bottom: 2px solid #f3f4f6;\n}\n.fx-tabs button {\n  background: none;\n  border: none;\n  padding: 0 5px 15px 5px;\n  margin-right: 30px;\n  font-size: 16px;\n  color: #6b7280;\n  cursor: pointer;\n  position: relative;\n  font-weight: 500;\n}\n.fx-tabs button.active {\n  color: #f97316;\n  font-weight: 600;\n}\n.fx-tabs button.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #f97316;\n}\n.fx-content {\n  padding-top: 24px;\n}\n\n/* === FX Pricing Tab Specifics === */\n.fx-pricing-list .list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.fx-pricing-list .list-header h3 {\n  font-size: 18px;\n  color: #111827;\n  margin: 0;\n}\n.fx-filters {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.fx-filters .form-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.fx-filters .form-group label {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 500;\n}\n.fx-filters .form-group select {\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  background-color: #fff;\n  font-size: 14px;\n}\n.action-button.primary {\n  background-color: #f97316;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n/* === FX Transaction Tab Specifics === */\n/* The transaction tab doesn't have a header above the table, so no specific styles needed */\n\n/* === Shared Table Styles === */\n.table-container {\n  overflow-x: auto;\n}\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.data-table th,\n.data-table td {\n  padding: 16px 24px;\n  text-align: left;\n  border-bottom: 1px solid #f3f4f6;\n  font-size: 14px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.data-table th {\n  background-color: #f2f7ff;\n  color: #174078;\n  font-weight: 600;\n}\n.data-table td {\n  color: #475569;\n}\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n.action-cell {\n  text-align: right !important;\n}\n.action-icon {\n  cursor: pointer;\n  color: #6b7280;\n  font-size: 20px;\n}\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.status-successful {\n  background-color: #dcfce7;\n  color: #166534;\n}\n.status-pending {\n  background-color: #fef9c3;\n  color: #854d0e;\n}\n.status-failed {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n/* === Shared Empty State, Loading, and Error Styles === */\n.page-loading,\n.page-error,\n.no-data-message,\n.fx-empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  font-size: 16px;\n  color: #6b7280;\n  background-color: #f9fafb;\n  border-radius: 8px;\n}\n.page-error {\n  color: #ef4444;\n}\n.fx-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.fx-empty-state .icon-wrapper {\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  background: #fff7ed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  font-size: 70px;\n  color: #f97316;\n}\n.fx-empty-state h3 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #4b5563;\n  margin-bottom: 32px;\n}\n\n/* --- RESPONSIVE STYLES --- */\n@media (max-width: 1200px) {\n  .fx-content-wrapper,\n  .page-content-wrapper {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 992px) {\n  .fx-tabs {\n    gap: 1rem;\n  }\n  .fx-content-wrapper,\n  .page-content-wrapper {\n    padding: 12px;\n  }\n  .fx-page .page-header h3 {\n    font-size: 22px;\n  }\n}\n\n@media (max-width: 768px) {\n  .fx-content-wrapper,\n  .page-content-wrapper {\n    padding: 8px;\n  }\n  .fx-tabs {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  .fx-content {\n    padding-top: 12px;\n  }\n  .table-container {\n    overflow-x: auto;\n  }\n  .data-table thead {\n    display: none;\n  }\n  .data-table tr {\n    display: block;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    padding: 1rem;\n  }\n  .data-table td {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid #f3f4f6;\n    white-space: normal;\n  }\n  .data-table td:last-child {\n    border-bottom: none;\n  }\n  .data-table td::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #4b5563;\n    text-align: left;\n  }\n}\n\n.pair-selector-section {\n  margin-bottom: 30px;\n}\n.selector-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 16px;\n}\n\n.pair-selector {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 12px;\n}\n\n/* ── Currency pair cards ── */\n.pair-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 16px 18px;\n  background: #fff;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 12px;\n  cursor: pointer;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s,\n    background 0.2s;\n  text-align: left;\n}\n.pair-btn:hover:not(:disabled) {\n  border-color: #fdba74;\n  box-shadow: 0 4px 16px rgba(249, 115, 22, 0.1);\n}\n.pair-btn.active {\n  border-color: #f97316;\n  background: #fff7ed;\n  box-shadow: 0 4px 20px rgba(249, 115, 22, 0.14);\n}\n.pair-btn.inactive {\n  opacity: 0.55;\n  cursor: not-allowed;\n  background: #f9fafb;\n}\n.pair-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.pair-rate {\n  font-size: 20px;\n  font-weight: 800;\n  color: #174078;\n  letter-spacing: -0.02em;\n}\n.pair-btn.active .pair-rate {\n  color: #f97316;\n}\n.coming-soon {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #9ca3af;\n  background: #f3f4f6;\n  padding: 2px 7px;\n  border-radius: 99px;\n}\n\n/* ── Stats row ── */\n.fx-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-bottom: 28px;\n}\n@media (max-width: 900px) {\n  .fx-stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.fx-stat-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 20px;\n  background: #fff;\n  border: 1px solid #f0f0f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n}\n.fx-stat-card__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n.fx-stat-card__icon--orange {\n  background: #fff7ed;\n}\n.fx-stat-card__icon--blue {\n  background: #eff6ff;\n}\n.fx-stat-card__icon--teal {\n  background: #f0fdf4;\n  gap: 3px;\n  font-size: 11px;\n  font-weight: 700;\n  flex-direction: row;\n}\n.fx-stat-card__pair-badge {\n  background: #fff;\n  border: 1px solid #d1fae5;\n  border-radius: 6px;\n  padding: 2px 6px;\n  color: #065f46;\n}\n.fx-stat-card__pair-arrow {\n  color: #9ca3af;\n  font-size: 10px;\n}\n.fx-stat-card__body {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n.fx-stat-card__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.fx-stat-card__value {\n  font-size: 22px;\n  font-weight: 800;\n  color: #111827;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n.fx-stat-card__change {\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 2px;\n}\n.fx-stat-card__change--up {\n  color: #16a34a;\n}\n.fx-stat-card__change--down {\n  color: #dc2626;\n}\n.fx-stat-card__meta {\n  font-size: 12px;\n  color: #9ca3af;\n  margin-top: 2px;\n}\n\n/* ── Inline messages ── */\n.message {\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 16px;\n}\n.message-info {\n  background: #eff6ff;\n  color: #1d4ed8;\n  border: 1px solid #bfdbfe;\n}\n.message-success {\n  background: #f0fdf4;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n}\n.message-error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.fx-inline-error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 10px 16px;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n.fx-table-empty {\n  text-align: center;\n  padding: 40px 24px !important;\n  color: #6b7280;\n  font-size: 14px;\n}\n.fx-pair-chip {\n  display: inline-block;\n  background: #fff7ed;\n  color: #c2410c;\n  font-weight: 600;\n  font-size: 13px;\n  padding: 3px 10px;\n  border-radius: 99px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
